import type { JSX } from "react";
import type { DeviceProfile } from "../types";
import { formatDate, formatNumber } from "./format";
import { labelForProperty, type ClassificationProperty } from "./labels";
import { SectionTable } from "./SectionTable";

export const ValueWithRangePanel = ({
  rows,
  valueLabel,
  property,
}: {
  rows: DeviceProfile["ips"];
  valueLabel: string;
  property?: ClassificationProperty;
}): JSX.Element => (
  <SectionTable
    headers={[valueLabel, "Count", "First seen", "Last seen"]}
    rows={rows.map((row) => [
      property ? labelForProperty(property, row.value) : (row.value ?? "—"),
      formatNumber(row.count),
      formatDate(row.firstSeen),
      formatDate(row.lastSeen),
    ])}
    emptyLabel="No values recorded."
  />
);
